export default [
    //流程配置
    {
        path: '/processLayout',
        component: () => import( '@/views/loud/processLayout/processLayout.vue'),
    },
    // 审核人员
    {
        path: '/processDetail',
        component: () => import( '@/views/loud/processLayout/processDetail.vue'),
    },
    // 查看详情
    {
        path: '/auditor',
        component: () => import( '@/views/loud/processLayout/auditor.vue'),
    }
] 